import React from 'react';
import { useAIAssistant } from '../AIAssistantProvider';

const ConversationList: React.FC = () => {
  const ctx = useAIAssistant();
  const { theme, canAdminSystem, conversations, conversationId, hasMoreConversations } = ctx;

  return (
    <>
      <div
        className="p-3 flex-1 hover-scroll min-h-0"
        onScroll={(e) => {
          const el = e.currentTarget;
          if (el.scrollTop + el.clientHeight >= el.scrollHeight - 40) {
            ctx.loadMoreConversations();
          }
        }}
      >
        {!canAdminSystem && (
          <div className="flex items-center justify-between mb-2 px-1">
            <h3 className={`text-[9px] font-bold uppercase tracking-wider ${theme.isDark ? 'text-slate-500' : 'text-slate-400'}`}>History</h3>
            <span className="w-1.5 h-1.5 bg-blue-500 rounded-full animate-pulse" />
          </div>
        )}

        <div className="space-y-0.5">
          {conversations.length === 0 ? (
            <p className={`text-[11px] px-2 py-3 ${theme.isDark ? 'text-slate-500' : 'text-slate-400'}`}>No conversations yet</p>
          ) : (
            conversations.map((conv) => (
              <div
                key={conv.id}
                onClick={() => ctx.handleSelectConversation(conv)}
                className={`w-full text-left px-2.5 py-2 rounded-lg transition-all group cursor-pointer ${
                  conv.id === conversationId
                    ? theme.isDark ? 'bg-slate-700' : 'bg-blue-50'
                    : theme.isDark ? 'hover:bg-slate-700/50' : 'hover:bg-slate-100'
                }`}
              >
                <div className="flex items-center justify-between gap-1.5">
                  <div className="min-w-0 flex-1">
                    <div className="flex items-center gap-1.5">
                      {conv.id === conversationId && (
                        <span className="w-1 h-1 bg-blue-500 rounded-full shrink-0" />
                      )}
                      <p className={`text-[11px] font-medium truncate ${
                        conv.id === conversationId
                          ? theme.isDark ? 'text-blue-400' : 'text-blue-600'
                          : theme.isDark ? 'text-slate-300' : 'text-slate-700'
                      }`}>
                        {conv.title && conv.title !== 'New Conversation' ? conv.title : 'Untitled Chat'}
                      </p>
                    </div>
                    <span className={`text-[9px] ${theme.isDark ? 'text-slate-500' : 'text-slate-400'} pl-${conv.id === conversationId ? '2.5' : '0'}`}>
                      {new Date(conv.updated_at).toLocaleDateString()}
                    </span>
                  </div>
                  <div className="opacity-0 group-hover:opacity-100 transition-opacity flex items-center shrink-0">
                    <button
                      onClick={(e) => ctx.handleExportConversation(conv, e)}
                      className={`p-1 rounded text-slate-400 ${theme.isDark ? 'hover:text-blue-400' : 'hover:text-blue-500'}`}
                      title="Export"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" className="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                      </svg>
                    </button>
                    <button
                      onClick={(e) => ctx.handleDeleteConversation(conv.id, e)}
                      className={`p-1 rounded text-slate-400 ${theme.isDark ? 'hover:text-red-400' : 'hover:text-red-500'}`}
                      title="Delete"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" className="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            ))
          )}
          {hasMoreConversations && conversations.length > 0 && (
            <button
              onClick={ctx.loadMoreConversations}
              className="w-full text-center text-[10px] text-blue-500 hover:text-blue-600 py-1.5 transition-colors"
            >
              Load more...
            </button>
          )}
        </div>
      </div>

      {/* New chat */}
      <div className={`px-3 py-2 border-t shrink-0 ${theme.isDark ? 'border-slate-700' : 'border-slate-200/60'}`}>
        <button
          onClick={ctx.handleNewChat}
          className={`w-full py-2 text-center rounded-lg flex items-center justify-center gap-1.5 text-[11px] font-medium transition-all ${
            theme.isDark
              ? 'text-slate-400 hover:bg-slate-700 hover:text-slate-200'
              : 'text-slate-500 hover:bg-slate-100 hover:text-slate-700'
          }`}
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
          </svg>
          New Chat
        </button>
      </div>
    </>
  );
};

export default ConversationList;
